export const messageEnumsConsts = {
  VALENTINE_MESSAGE: "VALENTINE_MESSAGE",
};
